;(function () {
  angular.module('contrast.ip').factory('SubnetMaskService', SubnetMaskService)

  function SubnetMaskService(ipRangeService) {
    'ngInject'

    var service = {
      calculateRange: calculateRange
    }

    function calculateRange(ip) {
      if (!angular.isUndefined(ip) && ip.indexOf('/' > -1)) {
        var cidr = new ipRangeService(ip)
        return {
          min: cidr.addressStart.address,
          max: cidr.addressEnd.address
        }
      }
      return ''
    }

    return service
  }
})()
